import React from 'react';

// const result = new URLSearchParams(location.search);
const nameByHangYe =''// result.get('name');

export const Banner32DataSource = {
  wrapper: { className: 'banner3' },
  textWrapper: {
    className: 'banner3-text-wrapper',
    children: [
      {
        name: 'nameEn',
        className: 'banner3-name-en l5m2vfpnx5h-editor_css',
        children: (
          <span>
            <p>Seeking Experience &amp; Keep you in my heart</p>
          </span>
        ),
      },
      {
        name: 'slogan',
        className: 'banner3-slogan l5m2tw7orq9-editor_css',
        children:'与您精彩互联 亮相世界前沿',
        texty: true,
      },
      {
        name: 'name',
        className: 'banner3-name',
        children: (
          <span>
            <span>
              <p>融云网络、比你自己更了解市场!</p>
            </span>
          </span>
        ),
      },
      {
        name: 'button',
        className: 'banner3-button l5m2ukn6ge-editor_css',
        children: (
          <span>
            <span>
              <span>
                <span>
                  <span>
                    <p>解决方案</p>
                  </span>
                </span>
              </span>
            </span>
          </span>
        ),
      },
      {
        name: 'time',
        className: 'banner3-time',
        children: (
          <span>
            <span>
              <p>@江西融云网络科技有限公司</p>
            </span>
          </span>
        ),
      },
    ],
  },
};
export const Content00DataSource = {
  wrapper: {
    className: 'home-page-wrapper content0-wrapper l5m6sme3sla-editor_css',
  },
  page: { className: 'home-page content0 l5m77y5nmtp-editor_css' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'image~l5m7b8jig4a',
        className: '',
        children:
          'https://gw.alipayobjects.com/zos/rmsportal/PiqyziYmvbgAudYfhuBr.svg',
      },
      {
        name: 'title',
        children: (
          <span>
            <span>
              <span>
                <span>
                  <p>行业解决方案</p>
                </span>
              </span>
            </span>
          </span>
        ),
      },
    ],
  },
  childWrapper: {
    className: 'content0-block-wrapper l5lwmvs1p5k-editor_css',
    children: [
      {
        name: 'block0',
        className: 'content0-block',
        md: 6,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children:
                'https://vkceyugu.cdn.bspapp.com/VKCEYUGU-734930d7-0782-4082-ab89-dc1d7326b48b/073ffac3-5357-4c44-876f-67b9e81332a7.svg',
            },
            {
              name: 'title',
              className: 'content0-block-title l5m3k55g7kr-editor_css',
              children: (
                <span>
                  <p>服务类型</p>
                </span>
              ),
            },
            {
              name: 'content',
              children: (
                <span>
                  <p>软件开发、技术服务、软硬件整体解决方案</p>
                </span>
              ),
            },
          ],
        },
      },
    ],
  },
};
